import { CompanyListItem, CompanyManagementUser, CompanyType } from "../types/companyManagementTypes";
import { CallResult, doApiDelete, doApiGet, doApiPatch, doApiPost } from "./Requests";

export const companyManagementApi = {
  getCompany: async (): Promise<CompanyType | null> => {
    try {
      const res = await doApiGet<CompanyType>("/api/companies/current");
      return res.success() && res.result ? res.result : null;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  getAllCompanies: (): Promise<CallResult<CompanyListItem[]>> =>
    doApiGet<CompanyListItem[]>("/api/companies"),

  bulkDownloadOnboardingFiles: () =>
    doApiGet<Blob>("/api/companymanagementuser/onboardingfiles", true),

  getCompanyManagementUsers: async (): Promise<CallResult<CompanyManagementUser[]>> => {
    return await doApiGet<CompanyManagementUser[]>("/api/companies/current/companymanagementusers");
  },

  createCompanyManagementUser: async (
    userData: {
      firstName: string;
      lastName: string;
      email: string;
    }
  ): Promise<CallResult<CompanyManagementUser>> => {
    return await doApiPost("/api/companies/current/companymanagementusers", userData);
  },

  editCompanyManagementUser: async (
    id: string,
    userData: {
      firstName: string;
      lastName: string;
    }
  ): Promise<CallResult<CompanyManagementUser>> => {
    return await doApiPatch(`/api/companies/current/companymanagementusers/${id}`, userData);
  },

  deleteCompanyManagementUser: async (
    id: string
  ): Promise<CallResult<null>> => {
    return await doApiDelete(`/api/companies/current/companymanagementusers/${id}`);
  },
};
